import { Colors } from '../../../../themes/colors';

export const CustomSelect = ({
  id,
  label,
  value,
  onChange,
  options,
  isError = false,
  isReadonly = false,
}) => {
  const selectedOption = options.find((option) => option.code === value);
  const displayValue = selectedOption ? selectedOption.name : '';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minWidth: 200,
      }}
    >
      {label && <p>{label}:</p>}

      {isReadonly ? (
        <input
          type="text"
          className="form-control"
          aria-label={label}
          style={{
            backgroundColor: 'inherit!important',
            fontSize: '1.25rem',
            height: 32,
            ...(isError
              ? {
                  border: `1px solid ${Colors.error_400}`,
                  backgroundColor: '#FEF9F9',
                }
              : {}),
          }}
          value={displayValue}
          readOnly
        />
      ) : (
        <select
          className="custom-select custom-select-lg"
          aria-label={label}
          style={{
            height: 32,
            ...(isError
              ? {
                  border: `1px solid ${Colors.error_400}`,
                  backgroundColor: '#FEF9F9',
                }
              : {}),
          }}
          value={value}
          onChange={(val) => {
            onChange(id, val.target.value !== 'all' ? val.target.value : '');
          }}
        >
          {options.map((option) => (
            <option key={option.code} value={option.code}>
              {option.name}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};
